export const config = {
    baseURL:"https://erp.cecyteqroo.edu.mx/api/"
}